import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import app from './firebase';

const db = getFirestore(app);

export async function markNotificationAsClosed(
  collectionName: string,
  userId: number,
  notificationId: number
) {
  try {
    const docId = `user_${userId}`;
    const docRef = doc(db, collectionName, docId);

    await setDoc(docRef, {
      [notificationId]: true,
    });
  } catch (e) {
    console.error('Error adding document: ', e);
  }
}

export async function getClosedNotifications(
  collectionName: string,
  userId: number
): Promise<number[]> {
  try {
    const docRef = doc(db, collectionName, `user_${userId}`);

    const docSnap = await getDoc(docRef);
    const closedNotifications: number[] = [];

    if (docSnap.exists()) {
      Object.entries(docSnap.data()).forEach(([key, _]) => {
        closedNotifications.push(Number(key));
      });

      return closedNotifications;
    } else {
      console.warn('No such document!');

      return closedNotifications;
    }
  } catch (e) {
    console.error('Error getting document:', e);
    return [];
  }
}
